module.exports = __webpack_public_path__ + "img/7.7e142f66.png";